import INSIGHTS_PATH from '../../apiPaths';

const preProcessRequestData = (data, idForUpdate = null) => {
  const {
    isActive,
    createdByUserId,
    lastModifiedByUserId,
    id,
    recordVersion,
    ...other
  } = data;
  const payload = {
    active: isActive === true || isActive === 'true',
    ...other,
  };
  if (idForUpdate || id) {
    payload.id = idForUpdate || id;
  }
  return payload;
};

const preProcessFetchData = data => {
  return { ...data };
};

const getFlowDefinitionsDataById = async (params, id) => {
  const getPageDataApiUrl = `${params?.getApiUrl()}${INSIGHTS_PATH}/${id}`;
  const response = await params?.get(getPageDataApiUrl);
  if (response?.ok) {
    return {
      data: preProcessFetchData(response?.data),
      errors: null,
    };
  }
  return {
    data: null,
    errors: response?.errors,
  };
};

export {
  preProcessRequestData,
  preProcessFetchData,
  getFlowDefinitionsDataById,
};
